export const TALLY_DEFAULT_LOGO_URL =
  "https://static.tally.xyz/24d36225-257a-44db-bfdc-39212dbe350b_original.png"

export const TALLY_DEFAULT_SOCIAL_PREVIEW =
  "https://static.tally.xyz/fe490962-2aa3-4187-b1b7-ba248e5ee3b6_original.png"

export const TALLY_DEFAULT_BANNER =
  "https://static.tally.xyz/dd2e2dce-90b5-481d-a87d-06fab5908d50_original.png"
